import { Col, Row } from '@/components/grid/grid-component';
import styled from 'styled-components';

const RowStyle = styled(Row)`
  width: 100% !important;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK} !important;
  margin-bottom: 25px !important;
  padding: 24px !important;
  margin-right: 0px !important;
  margin-left: 0px !important;
  justify-content: end !important;
`;

const Main = styled.div`
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  min-height: 100%;
  width: 100%;
  height: max-content;
`;

const CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 0.1;
  &:first-child {
    margin-left: 1rem;
  }
`;

const Title = styled.h4`
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: left;
  margin: 0;
`;

const CheckboxColStyle = styled(Col)`
  display: flex;
`;

const StyledRow = {
  RowStyle,
  Main,
  CheckBoxContainer,
  Title,
  CheckboxColStyle,
};

export default StyledRow;
